import { actions } from '../utils/constants';

const INITIAL_STATE = {
    token: '',
    userLogged: {},
    loading: false,
}

export default (state = INITIAL_STATE, action) => {
    const { type, payload } = action;

    switch (type) {
        case actions.SET_TOKEN:
            return { ...state, token: payload }

        case actions.CHANGE_USER_LOGGED:
            return { ...state, userLogged: payload };

        case actions.CHANGE_USER_LOGGED_LOADING:
            return { ...state, loading: payload };

        case actions.CLEAR_TOKEN:
            return { ...state, token: '', userLogged: {} }

        default:
            return state
    }
};


// WEBPACK FOOTER //
// ./src/App/auth.reducer.js